





































































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";

import MyConfig from "@/config.ts";

import TsUpload from "@/components/upload.vue";

import MyForm from "@/mixins/form";

import Base from "./base.vue";
import Detail from "./detail.vue";
import License from "./license.vue";

import Tags from "./tags.vue";
import Grounds from "./grounds.vue";
import Price from "./price.vue";
import Thumbnails from "./thumbnails.vue";
import ClosureTime from "./closure_time.vue";
import BankAccount from "./bank_account.vue";
import Report from "./report.vue";
import MonthExpense from "./month_expense.vue";
import AiStadium from "./aistadium.vue";
import Users from "./users.vue";
import Vips from "./vips.vue";
import Blocks from "./blocks.vue";

@Component({
  components: {
    TsUpload,
    Tags,
    Grounds,
    Price,
    Thumbnails,
    ClosureTime,
    BankAccount,
    Report,
    MonthExpense,
    AiStadium,
    Users,
    Vips,
    Blocks,
    Base,
    Detail,
    License,
  },
})
export default class extends Mixins(MyForm) {
  apiserver: string = MyConfig.casapi;

  @Prop() stadiumId!: number;

  @Prop({ default: "add" }) action!: string;

  grounds: any[] = [];

  fileList: any[] = [];

  previewVisible = false;

  previewImage = "";

  handleChange() {
    // 取消
  }

  handlePreview() {
    // 预览
  }

  handleCancel1() {
    // 取消
  }

  async loadGrounds() {
    const res = await this.$store.dispatch("stadium/getStadiumGrounds", {
      stadium_id: this.stadiumId,
    });
    if (res && res.Data && res.Data !== "{}") {
      this.grounds = res.Data;
    }
  }

  async mounted() {
    this.loadGrounds();
  }
}
